import { Constants } from "../../Utils/Constants";

export enum MESSAGE_SEVERITY_LEVEL {
    NOTICE = 1,
    WARNING = 2,
    ERROR = 3
}

//this class should cover the entire table area
export class MessageController extends Phaser.GameObjects.Container {

    public messages: Array<Message> = Array<Message>();
    public bigMessageCount: number = 0;
    public portraitMode: boolean = false;

    private padding: number = 0;

    constructor(public scene: Phaser.Scene, width: number, height: number, public numOfBigMessages: number = 4) {
        super(scene);
        scene.game.events.on(Constants.EVENTS.SHOW_MESSAGE_BOX, (text: string, messageSeverity: number = MESSAGE_SEVERITY_LEVEL.NOTICE, bigMessage: boolean = true, mouseX: number = 0, mouseY: number = 0) => {
            this.addMessage(text, messageSeverity, bigMessage, mouseX, mouseY);
        })

        this.setSize(width, height);
    }

    public onResize(): void {

    }

    private addMessage(text: string, messageSeverity: number = 0, bigMessage: boolean = true, mouseX: number = 0, mouseY: number = 0): void {
        let messageObject;
        let messageAlreadyExists = false;

        if (bigMessage) {
            this.messages.forEach(message => {
                if (message.messageText == text) {
                    messageAlreadyExists = true;
                    return;
                }
            });
        } else {
            this.messages.forEach(message => {
                if (message.messageText == text) {
                    if (message.savedX == mouseX && message.savedY == mouseY) {
                        messageAlreadyExists = true;
                    }
                    else {
                        message.Remove();
                    }
                    return;
                }
            });
        }

        if (messageAlreadyExists)
            return;

        this.padding = this.height * 0.01;
        let smallMessageSize = this.height / 6;
        let bigMessageHeight = (this.height - (this.padding * (this.numOfBigMessages + 1))) / this.numOfBigMessages;
        let bigMessageWidth = this.width * 0.8;

        if (bigMessage) {
            this.bigMessageCount += 1;
            this.cycleUpBigMessages();
            messageObject = new Message(this.scene, text, messageSeverity, true, this.width / 2 - bigMessageWidth / 2, this.height - bigMessageHeight - this.padding, bigMessageWidth, bigMessageHeight, this);
            messageObject.myBigMessageIndex = 1;
        }
        else {
            messageObject = new Message(this.scene, text, messageSeverity, false, mouseX, mouseY, smallMessageSize * 3, smallMessageSize, this);
            messageObject.savedX = mouseX;
            messageObject.savedY = mouseY;
        }

        messageObject.timeout = setTimeout(() => {
            this.scene.tweens.add({
                targets: messageObject,
                alpha: 0,
                duration: 250,
                ease: 'Power2',
                onComplete: () => {
                    messageObject.Remove();
                }
            })
        }, messageObject.severity * 2000);
        this.messages.push(messageObject);
        if (bigMessage)
            this.add(messageObject);
        else
            this.scene.children.add(messageObject);
    }

    //move all messages one slot up - when a new message arrives
    private cycleUpBigMessages(): void {
        this.messages.forEach(message => {
            if (message.bigMessage) {
                message.myBigMessageIndex += 1;
                if (message.myBigMessageIndex > this.numOfBigMessages) {
                    message.Remove();
                } else {
                    this.scene.tweens.add({
                        targets: message,
                        y: message.y - message.displayHeight - this.padding,
                        duration: 250,
                        ease: 'Power2',
                        paused: false
                    })
                }
            }
        });
    }

    //move all messages down as much as we can - when a message is destroyed
    public cycleDownBigMessages(): void {
        this.messages.slice().reverse().forEach(message => {
            if (message.bigMessage) {
                if (message.myBigMessageIndex != 1) {
                    let nobodyIsBelowMeOneSlot = true;

                    this.messages.forEach(someOtherMessage => {
                        if (someOtherMessage.myBigMessageIndex == message.myBigMessageIndex - 1)
                            nobodyIsBelowMeOneSlot = false;
                    });

                    if (nobodyIsBelowMeOneSlot) {
                        message.myBigMessageIndex -= 1;
                        this.scene.tweens.add({
                            targets: message,
                            y: message.y + message.displayHeight + this.padding,
                            duration: 250,
                            ease: 'Power2',
                            paused: false
                        })
                    }
                }
            }
        });
    }
}

export class Message extends Phaser.GameObjects.Container {
    public timeout: any;
    public myBigMessageIndex: number = 0;
    public savedX: number = 0;
    public savedY: number = 0;

    protected text: Phaser.GameObjects.Text;
    protected background: Phaser.GameObjects.Graphics;

    private clickImmunity: any;

    constructor(scene: Phaser.Scene, public messageText: string, public severity: MESSAGE_SEVERITY_LEVEL, public bigMessage: boolean, x: number, y: number, width: number, height: number, private parentController: MessageController) {
        super(scene);

        this.background = new Phaser.GameObjects.Graphics(scene);
        if (bigMessage) {
            this.clickImmunity = setTimeout(() => {
                let handler = (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
                    if (severity != MESSAGE_SEVERITY_LEVEL.ERROR) {
                        this.Remove();
                    }
                    event.stopPropagation();
                }
                this.background.setInteractive(new Phaser.Geom.Rectangle(0, 0, width, height), Phaser.Geom.Rectangle.Contains);
                this.background.on('pointerdown', handler, this);
            }, 1000);
        }

        this.text = new Phaser.GameObjects.Text(scene, 0, 0, messageText, Constants.MESSAGE_BOX.FONT);
        this.text.setOrigin(0.5);

        this.add(this.background)
        this.add(this.text);

        this.Resize(width, height, x, y);
    }

    Resize(width: number, height: number, x: number, y: number): void {
        this.setSize(width, height);
        this.setPosition(x, y);

        this.background.clear();
        this.background.fillStyle(0x000000, 1);
        this.background.fillRoundedRect(0, 0, width, height, height / 15);
        this.background.setAlpha(0.83);
        if (this.bigMessage && this.background.input)
            this.background.input.hitArea.setSize(width, height);

        this.text.setFontSize(height / 3)
        if (this.text.displayWidth > width) this.text.setFontSize(parseInt(this.text.style.fontSize) * ((width * 0.90) / this.text.displayWidth));

        this.text.setPosition(width / 2, height / 2);
    }

    public Remove(): void {
        this.myBigMessageIndex = -1;
        if (this.timeout)
            clearTimeout(this.timeout);
        if (this.bigMessage) {
            if (this.clickImmunity)
                clearTimeout(this.clickImmunity);

            this.parentController.bigMessageCount -= 1;
            if (this.parentController.bigMessageCount > 0)
                this.parentController.cycleDownBigMessages();
        }
        this.parentController.messages.splice(this.parentController.messages.indexOf(this), 1);
        this.destroy();
    }
}
